import { AGGRID_AUTOCOLUMN_ID, type Position } from '@talos/kyoko';
import type { GetContextMenuItemsParams } from 'ag-grid-community';

/**
 * Just a static function which returns "SubAccount" as the filtering column for the group column.
 * To be used when in tree (hierarchical) mode.
 */
export function treeBlotterContextMenuColumnResolver(params: GetContextMenuItemsParams): string | undefined {
  const isGroupingColumn = params.column?.getColId() === AGGRID_AUTOCOLUMN_ID;
  return isGroupingColumn ? ('SubAccount' satisfies keyof Position) : undefined;
}
